module.exports = "<div class=\"header\">\r\n    <div class=\"logo-container\">\r\n      <img src=\"assets/logo-branca.jpg\" alt=\"SEST SENAT Logo\">\r\n    </div>\r\n  </div>\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/_public-layout/header/header.component.html
// module id = ./src/app/components/_public-layout/header/header.component.html
// module chunks = main